// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var MedicalBiGender;
(function (MedicalBiGender) {
    MedicalBiGender["Male"] = "M";
    MedicalBiGender["Female"] = "F";
    MedicalBiGender["Unknown"] = "U";
})(MedicalBiGender || (MedicalBiGender = {}));
//# sourceMappingURL=medicalBiGender.js.map